import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../vue";
import { IMethodEditorState } from "../MethodEditorState";
import DocItem from "./DocItem";
import styles from "./Doc.style.module.css";
import { DocState } from "../DocState";
import { reportClick } from "../../../tools/report";
const docMod = '文档模块';
let DocsPanel = class DocsPanel extends Vue {
  get state() {
    return DocState.getInstance();
  }
  get docTypes() {
    const types = Boolean(this.state.searchKeyword.length) ? this.state.docTypesInSearch : this.state.docTypes;
    return types.filter(item => item.docs.length);
  }
  mounted() {
    this.$watch(() => this.state.currentType, val => {
      var _this$state$docTypes$;
      reportClick({
        eid: ((_this$state$docTypes$ = this.state.docTypes.find(item => item.id === val)) === null || _this$state$docTypes$ === void 0 ? void 0 : _this$state$docTypes$.name) || 'unknown',
        mod: docMod
      });
    });
  }
  render() {
    const h = arguments[0];
    if (!this.state.currentType) {
      return null;
    }
    return h("div", {
      "attrs": {
        "wj-mod": docMod
      }
    }, [h("a-input-search", {
      "attrs": {
        "placeholder": "输入关键字进行搜索",
        "wj-eid": "搜索"
      },
      "style": "margin-bottom:12px;",
      "model": {
        value: this.state.searchKeyword,
        callback: $$v => {
          this.$set(this.state, "searchKeyword", $$v);
        }
      }
    }), h("a-tabs", {
      "attrs": {
        "type": "card"
      },
      "model": {
        value: this.state.currentType,
        callback: $$v => {
          this.$set(this.state, "currentType", $$v);
        }
      }
    }, [this.docTypes.map(item => h("a-tab-pane", {
      "key": item.id,
      "attrs": {
        "tab": item.name
      }
    }, [h("div", {
      "class": styles.docContent,
      "style": this.contentStyle
    }, [item.docs.map(doc => h(DocItem, {
      "attrs": {
        "doc": doc
      }
    }))])]))])]);
  }
};
__decorate([IMethodEditorState], DocsPanel.prototype, "editorState", void 0);
__decorate([Prop({
  default: {}
})], DocsPanel.prototype, "contentStyle", void 0);
DocsPanel = __decorate([Component({
  name: 'DocsPanel'
})], DocsPanel);
export default DocsPanel;
//# sourceMappingURL=DocsPanel.js.map
